<template>
	<div>
		<div class="row">
			<div class="input-field col s12 m6 l6 xl6">
				<input id="cpf" name="cpf" type="text" class="validate" @input="verifyCpf" maxlength="11" v-model='usu.cpf' 
						v-bind:class="{ 'red-text': usu.cpf.length != 11, 'green-text': usu.cpf.length == 11 }" required>
				<label for="cpf">CPF <small>(somente números)</small></label>
			</div>
			<div class="input-field col s12 m6 l6 xl6">
				<input readonly id="email" name="email" type="text"  v-model='usu.email' required>
				<label for="email" class='active'>e-mail</label>
			</div>
		</div>
		<div class="row">
			<div class="input-field col s12 m6 l6 xl6">
				<input readonly id="name" name="name" type="text"  v-model='usu.name' required>
				<label for="name" class='active'>Nome</label>
			</div>
			<div class="input-field col s12 m6 l6 xl6">
				<input readonly id="nome_social" name="nome_social" type="text"  v-model='usu.nome_social' required>
				<label for="nome_social" class='active'>Nome social</label>
			</div>
		</div>

		<div class="row">
			<div class="input-field col s12 m6 l6 xl6">
				<input readonly id="sira" name="sira" type="text" v-model='usu.bolsista.sira' required>
				<label for="sira" class='active'>DRE</label>
			</div>
			<div class="input-field col s12 m6 l6 xl6">
				<input readonly id="curso" name="curso" type="text" v-model='usu.bolsista.curso' required>
				<label for="curso" class='active'>Curso</label>
			</div>
		</div>
		
		<div class="row">
			<div class="input-field col s12 m6 l6 xl6">
				<input readonly id="lattes" name="lattes" type="text" v-model='usu.lattes' required>
				<label for="lattes" class='active'>ID do Lattes</label>
			</div>
		</div>
		
		<input type="hidden" id="aluno_id" name="aluno_id" v-model='usu.id'>
		
		<div class="row">
			<div class="input-field col s6 m3 l3 xl3">
				<button type="submit" class="btn" :disabled='!usu.id' onclick="return confirmarAtribuir();">
					<i class="material-icons left">save</i>
				Salvar</button>
			</div>
			<div class="input-field col s6 m3 l3 xl3">
				<button type="reset" class="btn indigo" @click="clear">
					<i class="material-icons right">clear</i>
						Limpar</button>
			</div>
		</div>
	</div>
</template>

<script>
    export default {
		name: "VueBolsaAtribuicaoForm",
		props: [
			'id'
		],
		data () {
			return {
				usu: {cpf: '', name: ' ', email: ' ', nome_social: ' ', lattes: ' ', bolsista: {curso: ' ', sira: ' '}}
			}
		},
		computed: {

		},
		methods: {
			verifyCpf() {
				if (this.usu.cpf.length == 11) {
					this.$http.get('/api/bolsas/bolsista/true/' + this.usu.cpf).then((req) => {
						if (req.data) {
							this.usu = req.data;
							document.getElementById('aluno_id').value = this.usu.id;
						}
				  }).catch(error => {
						showMsg(error.data.msg, 0);
						this.clear(null, this.usu.cpf);
					});
				} else 
					this.clear(null, this.usu.cpf)
			},
			clear (ev, cpfInput = '') {
				this.usu = {
					cpf: cpfInput,
					name: '',
					email: '',
					nome_social: '',
					lattes: '',
					bolsista: {sira: '', curso: ''}
				}
			},
		},
		mounted: function () {
		},

    }
</script>
